import { ContainerAtom } from "../container";
import styles from "./styles.module.scss";

export enum RowState {
  default,
  error,
  success,
  uploading,
}

export interface TableRowState {
  state: RowState;
  index: number;
}

interface Props {
  theads?: any[];
  rows?: any[][];
  columnWidth?: string[];
  highlight?: number;
  allowSelected?: boolean;
  states?: TableRowState[];
  addButton?: JSX.Element;
}

export function TableAtom(props: Readonly<Props>) {
  const headerRow = props.theads?.map((i: any, index: number) => {
    return (
      <th
        key={i + index}
        className={styles.header_cell}
        style={props.columnWidth && index <= props.columnWidth.length ? { width: props.columnWidth[index] } : {}}
      >
        <p className={styles.item_heading}>{i}</p>
      </th>
    );
  });

  let counter = 0;
  const rows = props.rows?.map((column: any[], indexRow: number) => {
    let classname: string = "";

    if (props.highlight !== undefined && indexRow === props.highlight && props.allowSelected) {
      classname += ` ${styles.highlight}`;
    }

    if (indexRow === 0) {
      classname += ` ${styles.border_top}`;
    }

    if (props.states != null) {
      const state = props.states.find((rowState: TableRowState) => rowState.index === indexRow)?.state;
      switch (state) {
        case RowState.uploading:
          classname += ` ${styles.uploading}`;
          break;
        case RowState.error:
          classname += ` ${styles.error}`;
          break;
        case RowState.success:
          classname += ` ${styles.success}`;
          break;
        case RowState.default:
        default:
          break;
      }
    }

    counter++;
    return (
      <tr key={counter} className={classname}>
        {column.map((col: any) => {
          counter++;
          return (
            <td key={counter} className={styles.cell}>
              <div className={styles.item}>{col}</div>
            </td>
          );
        })}
      </tr>
    );
  });

  const addAttachment = (
    <tr className={styles.header_cell + " " + styles.grey}>
      <td className={styles.cell}>
        <div className={styles.item}>{props.addButton}</div>
      </td>
    </tr>
  );

  return (
    <ContainerAtom>
      <div className={styles.container}>
        <table>
          <tbody>
            {headerRow && (
              <tr key="header" className={styles.header}>
                <th className={styles.header_cell}>
                  <div className={styles.item}></div>
                </th>
                {headerRow}
              </tr>
            )}
            {rows}
            {props.addButton ? addAttachment : undefined}
          </tbody>
        </table>
      </div>
    </ContainerAtom>
  );
}
